import React, {
  SelectHTMLAttributes,
  DetailedHTMLProps,
  ChangeEvent,
  ReactNode,
} from "react";
import s from "./SuperSelect.module.css";
import { arrType, oneArrElementType } from "../../HW7";

type DefaultSelectPropsType = DetailedHTMLProps<
  SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
>;

type SuperSelectPropsType = DefaultSelectPropsType & {
  options: arrType;
  onChangeOption: (option: number) => void;
};

const SuperSelect: React.FC<SuperSelectPropsType> = ({
  options,
  className,
  onChange,
  onChangeOption,
  ...restProps
}) => {
  const mappedOptions = options
    ? options.map((o) => (
        <option
          id={"hw7-option-" + o.id}
          className={s.option}
          key={o.id}
          value={o.id}
        >
          {o.value}
        </option>
      ))
    : []; // map options with key

  const onChangeCallback = (e: ChangeEvent<HTMLSelectElement>) => {
    // делают студенты
    onChangeOption(Number(e.currentTarget.value));
  };
  // const onChangeCallback = (e: ChangeEvent<HTMLSelectElement>) => {
  //   debugger;
  //   onChangeOption?.(Number(e.currentTarget.value));
  //   onChange?.(e);
  // };

  const finalSelectClassName = s.select + (className ? " " + className : "");

  return (
    <select
      className={finalSelectClassName}
      onChange={onChangeCallback}
      {...restProps}
    >
      {mappedOptions}
    </select>
  );
};

export default SuperSelect;
